import { gql } from '@apollo/client';

export const FederalRdTaxCreditDocumentsFragment = gql`
  fragment FederalRdTaxCreditDocuments on FederalRdTaxCreditDocuments {
    id
    filingMethod
    isReducedCredit
    taxCreditFormFileName
    taxCreditFormUrl
    taxCreditFormStatus
    taxCreditFormMissingInformation
    taxCreditFormGeneratedDate
    taxWriteUpPdfFileName
    taxWriteUpPdfUrl
    taxWriteUpStatus
    taxWriteUpMissingInformation
    taxWriteUpGeneratedDate
  }
`;
